/**
 * Trending Categories Constants
 * Used in the Trending Styles section
 *
 * Balance between specificity and findability:
 * - Too generic = wrong products
 * - Too specific = no results from Rakuten
 *
 * These terms are tested to return actual Rakuten products
 */

export const TRENDING_CATEGORIES = [
  'women dress',           // Simple but effective
  'leather jacket',        // Works well (proven in logs)
  'sport elegant shoes',         // Generic enough to find products
  'sunglasses',            // Popular accessory, many products available
  'men jeans'              // Generic but will show jeans
];

/**
 * Display names for trending categories
 * Maps search terms to user-friendly display names
 */
export const TRENDING_DISPLAY_NAMES = {
  'women dress': 'Designer Dress',
  'leather jacket': 'Leather Jacket',
  'sport elegant shoes': 'Sport Elegant',
  'sunglasses': 'Sunglasses',
  'men jeans': 'Slim Fit Jeans'
};

export default TRENDING_CATEGORIES;


